export type DateRangePreset = 'currentYear' | 'previousYear' | 'currentMonth' | 'last30Days';

export const DATE_RANGE_PRESETS: ReadonlyArray<{ key: DateRangePreset; label: string }> = [
    { key: 'currentYear', label: 'Current year' },
    { key: 'previousYear', label: 'Previous year' },
    { key: 'currentMonth', label: 'Current month' },
    { key: 'last30Days', label: 'Last 30 days' },
];

export type DateRangeFilterValue = ReadonlyArray<Date | null | undefined> | null | undefined;

const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

function toLocalDay(value: unknown): number | null {
    let date: Date;
    if (value instanceof Date) {
        date = value;
    } else if (typeof value === 'string' && value.trim() !== '') {
        const text = value.trim();
        const dateOnly = DATE_ONLY.exec(text);
        date = dateOnly ? new Date(+dateOnly[1], +dateOnly[2] - 1, +dateOnly[3]) : new Date(text);
    } else {
        return null;
    }
    return Number.isNaN(date.getTime())
        ? null
        : new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}

export function matchesDateRange(value: unknown, range: DateRangeFilterValue): boolean {
    const from = toLocalDay(range?.[0]);
    if (from === null) return true;
    const to = toLocalDay(range?.[1]) ?? from;
    const day = toLocalDay(value);
    return day !== null && day >= from && day <= to;
}

export function getDateRangePreset(preset: DateRangePreset, today: Date = new Date()): [Date, Date] {
    const year = today.getFullYear();
    const month = today.getMonth();
    const day = today.getDate();
    switch (preset) {
        case 'currentYear':
            return [new Date(year, 0, 1), new Date(year, 11, 31)];
        case 'previousYear':
            return [new Date(year - 1, 0, 1), new Date(year - 1, 11, 31)];
        case 'currentMonth':
            return [new Date(year, month, 1), new Date(year, month + 1, 0)];
        case 'last30Days':
            return [new Date(year, month, day - 29), new Date(year, month, day)];
    }
}